import axios from "axios"
import setCalculatedValues from "./calculatedValues"




export default function loadJSON(e, t) {
    let loaddata = JSON.parse(sessionStorage.getItem('loaddata'));
    let siteID = sessionStorage.getItem('siteID');
    let siteLegacy = document.querySelector('[data-legacy]');
    let loanPageID = document.querySelector('[data-loan-page-id]').dataset.loanPageId;
    let siteLang = document.documentElement.lang;
    let langOption = '';

    let insuranceChecbox = document.querySelector('input[id=insurance]');

    let loaddataString = "";

    let legacyID = "";
    if (siteLegacy) {
        legacyID = siteLegacy.dataset.legacy;
        if (!siteID) {
            siteID = legacyID;
        }
    }

    if (siteLang == 'nb') {
        langOption = 'no'
    } else {
        langOption = 'se'
    }

    console.log(langOption)

    if (insuranceChecbox) {
        let calcInsurance = document.querySelector('.calc-insuranceprice');

        insuranceChecbox.addEventListener('change', function () {
            if (this.checked) {
                loaddataString = '/loaddata/' + legacyID + '-insurance-loaddata_' + langOption + '.json';
                calcInsurance.parentElement.classList.remove('hidden');

                axios.get(loaddataString).then((response) => {
                    loaddata = response.data
                    sessionStorage.setItem('loaddata', JSON.stringify(response.data));

                    //setCalculatedValues
                    for (let i = 0; i < loaddata.months.length; i++) {
                        if (e == loaddata.months[i].amount && t == loaddata.months[i].month) {
                            const j = loaddata.months[i];

                            setCalculatedValues(
                                j.amount,
                                j.month,
                                j.monthlyPay,
                                j.debitrente,
                                j.creditTotal,
                                j.aop,
                                j.totalkreditcost,
                                j.kreditcost,
                                j.setupfeeloan,
                                j.insuranceprice
                            )
                        }
                    }
                })
            } else {
                loaddataString = '/loaddata/' + legacyID + '-' + loanPageID + '-loaddata_' + langOption + '.json';
                calcInsurance.parentElement.classList.add('hidden');

                axios.get(loaddataString).then((response) => {
                    loaddata = response.data
                    sessionStorage.setItem('loaddata', JSON.stringify(response.data));

                    //setCalculatedValues
                    for (let i = 0; i < loaddata.months.length; i++) {
                        if (e == loaddata.months[i].amount && t == loaddata.months[i].month) {
                            const j = loaddata.months[i];

                            setCalculatedValues(
                                j.amount,
                                j.month,
                                j.monthlyPay,
                                j.debitrente,
                                j.creditTotal,
                                j.aop,
                                j.totalkreditcost,
                                j.kreditcost,
                                j.setupfeeloan,
                                j.insuranceprice
                            )
                        }
                    }
                })
            }
        })
    }

    loaddataString = '/loaddata/' + legacyID + '-' + loanPageID + '-loaddata_' + langOption + '.json';

    console.log(loaddataString)

    if (!loaddata) {
        axios.get(loaddataString).then((response) => {
            loaddata = response.data
            sessionStorage.setItem('loaddata', JSON.stringify(response.data));

            //setCalculatedValues
            for (let i = 0; i < loaddata.months.length; i++) {
                if (e == loaddata.months[i].amount && t == loaddata.months[i].month) {
                    const j = loaddata.months[i];

                    setCalculatedValues(
                        j.amount,
                        j.month,
                        j.monthlyPay,
                        j.debitrente,
                        j.creditTotal,
                        j.aop,
                        j.totalkreditcost,
                        j.kreditcost,
                        j.setupfeeloan,
                        j.insuranceprice
                    )
                }
            }
        })
    } else {

        //setCalculatedValues
        for (let i = 0; i < loaddata.months.length; i++) {
            if (e == loaddata.months[i].amount && t == loaddata.months[i].month) {
                const j = loaddata.months[i];

                setCalculatedValues(
                    j.amount,
                    j.month,
                    j.monthlyPay,
                    j.debitrente,
                    j.creditTotal,
                    j.aop,
                    j.totalkreditcost,
                    j.kreditcost,
                    j.setupfeeloan,
                    j.insuranceprice
                )
            }
        }
    }
}

